var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-action-bar"},[(_vm.editor)?_c('div',[_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
          .run()}}},[_vm._v(" Insert Table ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addColumnBefore()
          .run()}}},[_vm._v(" Add Column Before ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addColumnAfter()
          .run()}}},[_vm._v(" Add Column After ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteColumn()
          .run()}}},[_vm._v(" Delete Column ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addRowBefore()
          .run()}}},[_vm._v(" Add Row Before ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addRowAfter()
          .run()}}},[_vm._v(" Add Row After ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteRow()
          .run()}}},[_vm._v(" Delete Row ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteTable()
          .run()}}},[_vm._v(" Delete Table ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .mergeCells()
          .run()}}},[_vm._v(" Merge Cells ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .splitCell()
          .run()}}},[_vm._v(" Split Cell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderColumn()
          .run()}}},[_vm._v(" Toggle Header Column ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderRow()
          .run()}}},[_vm._v(" Toggle Header Row ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderCell()
          .run()}}},[_vm._v(" Toggle Header Cell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .mergeOrSplit()
          .run()}}},[_vm._v(" Merge Or Split ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .setCellAttribute('colspan', 2)
          .run()}}},[_vm._v(" Set Cell Attribute ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .fixTables()
          .run()}}},[_vm._v(" Fix Tables ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .goToNextCell()
          .run()}}},[_vm._v(" Go To Next Cell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .goToPreviousCell()
          .run()}}},[_vm._v(" Go To Previous Cell ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }